import React from 'react';
import XLogo from 'assets/images/lBlack.png';
import MiscLogo from 'assets/svgs/rss.svg';
import FBLogo from 'assets/images/fb-logo.png';
import InstaLogo from 'assets/images/insta-logo.png';
import {
  FacebookFilled,
  InstagramFilled,
  YoutubeFilled,
} from '@ant-design/icons';

interface SocialIconProps {
  social_network: string;
}

interface SocialLogoProps {
  social_network: string;
  style?: React.CSSProperties;
}

const SocialIcon: React.FC<SocialIconProps> = ({ social_network}) => {
  if (social_network === 'facebook') return <FacebookFilled/>;
  if (social_network === 'twitter' || social_network === 'x') return <img className="x-logo" src={XLogo} alt="X"/>;
  if (social_network === 'youtube') return <YoutubeFilled />;
  if (social_network == 'misc') return <MiscLogo />;
  return <InstagramFilled />;
};

export default SocialIcon;
